module.exports = __webpack_public_path__ + "media/Landing_Video.cc22fc2a.mp4";